import { render, staticRenderFns } from "./UserCommunications.vue?vue&type=template&id=92d3d95c&"
import script from "./UserCommunications.vue?vue&type=script&lang=ts&"
export * from "./UserCommunications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports